import {Moment} from 'moment';
import { Address2ComponentValue } from './address2-component.domain';
import { AggregatorSearchComponentValue } from './aggregator-search-component.domain';
import { BrokerageSelectionValue } from './brokerage-selection-component.domain';
import { BusinessSearchValue } from './business-search-component.domain';
import { EntityTypeValue } from './entity-type-component.domain';
import { GuarantorValue } from './guarantor-component.domain';
import { LoanPurposeValue } from './loan-purpose-selection-component.domain';
import { PaymentFrequencyValue } from './payment-frequency-selection-component.domain';
import { PrimaryIndustrySelectionValue } from './primary-industry-selection-component.domain';
import { ReferenceValue } from './reference-component.domain';
import {SecondaryIndustrySelectionValue } from './secondary-industry-selection-component.domain';
import { ContactValue, SummaryContactValue } from './select-contact-component.domain';
import { UserSelectionValue } from './user-selection-component.domain';
import { YesNoValue } from './yes-no-component.domain';
import {ApplicationApplicant} from '../types.domain';
import { SalesforceContactSameAccountSelectionValue } from './salesforce-contact-same-account-selection-component.domain';
import {LoanTermsSelectionWithInputValue} from "./loan-terms-selection-with-input-component.domain";
import { SubdivisionIndustrySelectionValue } from './subdivision-industry-selection-component.domain';

export interface BusinessFinanceSummary {
  repayment: string;
  estimatedDrawDownDate: Moment;
  applicationId: string;

  organisation: BusinessSearchValue;
  addtionalBrokerCorrespondent?: UserSelectionValue;
  broker: AggregatorSearchComponentValue;

  loanPurpose: LoanPurposeValue | null;
  loanAmount: number;
  loanTerms: LoanTermsSelectionWithInputValue;
  brokerage: BrokerageSelectionValue;
  paymentFrequency: PaymentFrequencyValue;
  propertyOwner: YesNoValue;
  adverseOnFile: YesNoValue;
  equifaxScoreAboveThreshold: YesNoValue;
  organisationType: EntityTypeValue;
  abn: string;
  acn: string;
  annualRevenue: number;
  primaryIndustry: PrimaryIndustrySelectionValue;
  industrySector: SecondaryIndustrySelectionValue;
  subdivisionIndustrySector: SubdivisionIndustrySelectionValue;
  primaryBusinessAddress: Address2ComponentValue;
  // Broker flows only; the direct-sale pages never collect it.
  registeredBusinessAddress?: Address2ComponentValue;

  applicants: Exclude<ApplicationApplicant, null>,

  guarantors: GuarantorValue;

  primaryContact: ContactValue;

  // Broker flows only; the direct-sale pages have no Individual Details step to list.
  contacts?: SummaryContactValue[];

  references: ReferenceValue;

  applicationNotes: string;
  directorScore: boolean;
  brokerContact:SalesforceContactSameAccountSelectionValue;
  docFeeFinanced: YesNoValue;
}
